import { generateDeviceInfo } from "../utils"

const convertToSnakeCase = (word) => {
  return word
    .replace(/\.?([A-Z]+)/g, (x, y) => {
      return "_" + y.toLowerCase()
    })
    .replace(/^_/, "")
}

const formatObject = (object, customKeyName) => {
  const newData = {}

  for (const key in object) {
    if (object[key] && key !== 'topicArn') {
      const newKeyName = customKeyName
        ? `${customKeyName}_${convertToSnakeCase(key)}`
        : convertToSnakeCase(key)

      if (object[key] instanceof Array || object[key] instanceof Object) {
        newData[newKeyName] = JSON.stringify(object[key])
      } else {
        newData[newKeyName] = object[key]
      }

    }
  }

  return newData
}

const generateUserData = (user) => {
  const deviceInfo = generateDeviceInfo()
  const formatDeviceInfo = formatObject(deviceInfo, 'device')
  const userData = {
    ...formatDeviceInfo
  }

  if (user) {
    const { account, profile, telco } = user

    if (telco) {
      userData.telcoOperator = telco.msisdn
      userData.telcoMsisdn = telco.operator
    }

    Object.assign(userData, formatObject(account, 'account'))
    Object.assign(userData, formatObject(profile, 'profile'))
  }

  return userData
}

const fbPixel = (event, options = { params: {}, user: null }) => {
  const { params = {}, user = null } = options
  const userData = generateUserData(user)
  const time = new Date().getTime()
  const property = formatObject(params)

  const payload = {
    ...userData,
    ...property,
    time,
  }

  // console.log('fb_pixel_event', {
  //   eventName: event,
  //   payload
  // })

  window.fbq('trackCustom', event, payload)
}

export default fbPixel